import React from 'react';
import { Button, Col, Form, Modal, Row } from 'react-bootstrap';

const MoreInfo = ({ show, hide }) => {
    return (
        <Modal show={show} onHide={hide} size="lg" centered >
            <Modal.Header>
                <Modal.Title as="h6">Organization Info</Modal.Title>
                <Button bsPrefix="btn-close" onClick={hide} >
                    <span aria-hidden="true">×</span>
                </Button>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Row className="gx-3">
                        <Col sm={6}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Name</Form.Label>
                                <Form.Control type="text" defaultValue="Acme Corporation" placeholder="Name" name="name1" />
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Industry</Form.Label>
                                <Form.Control type="text" defaultValue="Supply Chain" placeholder="Industry" name="lastname1" />
                            </Form.Group>
                        </Col>
                    </Row>
                    <Row className="gx-3">
                        <Col sm={6}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Address</Form.Label>
                                <Form.Control type="email" defaultValue="128 St Bank Lane, Lewes, Delaware" placeholder="Address" name="emailid1" />
                            </Form.Group>
                        </Col>
                        <Col sm={6}>
                            <Form.Group className="mb-3" >
                                <Form.Label>ZipCode</Form.Label>
                                <Form.Control type="text" defaultValue="198382" placeholder="Zip" name="birthday1" />
                            </Form.Group>
                        </Col>
                    </Row>
                </Form>
            </Modal.Body>
            <Modal.Footer className="align-items-center">
                <Button variant="secondary" onClick={hide}>Discard</Button>
                <Button variant="primary" onClick={hide}>Update</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default MoreInfo
